export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 px-4 md:px-6 lg:px-10 bg-background-900">
      <div className="max-w-5xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold font-heading text-foreground-50 mb-4">
              随时随地 · 高清追剧
            </h2>
            <p className="text-sm md:text-base text-foreground-300 leading-relaxed mb-6">
              午马影院全面适配移动端设备，无论你是在通勤路上、午休间隙还是睡前时光，打开手机浏览器即可畅享高清电视剧。无需下载安装，即开即看，追剧从未如此便捷。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4">
              <div className="flex items-center gap-2 px-5 py-3 bg-background-50/10 rounded-xl border border-foreground-300/10 cursor-pointer hover:bg-background-50/20 transition-colors">
                <i className="ri-android-line text-primary-400 text-xl"></i>
                <span className="text-sm text-foreground-200 whitespace-nowrap">安卓端访问</span>
              </div>
              <div className="flex items-center gap-2 px-5 py-3 bg-background-50/10 rounded-xl border border-foreground-300/10 cursor-pointer hover:bg-background-50/20 transition-colors">
                <i className="ri-apple-line text-primary-400 text-xl"></i>
                <span className="text-sm text-foreground-200 whitespace-nowrap">iOS 端访问</span>
              </div>
            </div>
          </div>

          <div className="flex-shrink-0 w-56 md:w-64">
            <div className="aspect-[9/16] rounded-3xl overflow-hidden border-2 border-foreground-300/10 shadow-2xl bg-background-800">
              <div className="h-full flex flex-col">
                <div className="h-10 bg-background-950/50 flex items-center justify-center">
                  <div className="w-16 h-1 rounded-full bg-foreground-300/20"></div>
                </div>
                <div className="flex-1 flex flex-col items-center justify-center p-4">
                  <div className="w-12 h-12 rounded-2xl bg-primary-500 flex items-center justify-center mb-3">
                    <i className="ri-movie-2-fill text-background-50 text-xl"></i>
                  </div>
                  <div className="text-sm font-bold text-foreground-100 font-heading">午马影院</div>
                  <div className="text-xs text-foreground-400 mt-1">高清追剧 · 即开即看</div>
                  <div className="mt-4 w-full space-y-2">
                    <div className="h-1.5 rounded-full bg-background-600"></div>
                    <div className="h-1.5 rounded-full bg-background-600 w-3/4"></div>
                  </div>
                </div>
                <div className="h-14 bg-background-950/50 flex items-center justify-center">
                  <div className="flex gap-6">
                    <i className="ri-home-4-fill text-primary-400 text-lg"></i>
                    <i className="ri-search-line text-foreground-400 text-lg"></i>
                    <i className="ri-heart-line text-foreground-400 text-lg"></i>
                    <i className="ri-user-line text-foreground-400 text-lg"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}